/* ===========================================================
   Bin Hero — storefront behaviour
   Collection area, Monday–Saturday date picker, booking form
   =========================================================== */
(function () {
  "use strict";

  /* --- Collection area: 225 Sydney postcodes as contiguous ranges --------
     Out: outer Northern Beaches, outer Hornsby Shire, most of Sutherland,
     Camden, outer Penrith, Wollondilly, Hawkesbury, Blue Mountains.
     Edit these pairs to change coverage. Keep in step with the
     Shopify local delivery zone under Settings > Shipping and delivery. */
  var SYDNEY = [[2000,2075],[2077,2077],[2085,2093],[2095,2095],[2109,2156],
                [2160,2224],[2555,2556],[2558,2566],[2747,2747],[2750,2750],[2759,2770]];
  var DAYS = "Monday to Saturday";
  var CUTOFF_HOUR = 21;        // 9pm cut-off for next-day collection
  var DOW = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  var MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  function inArea(n) {
    for (var i = 0; i < SYDNEY.length; i++) {
      if (n >= SYDNEY[i][0] && n <= SYDNEY[i][1]) return true;
    }
    return false;
  }
  function validPostcode(v) { return /^\d{4}$/.test(String(v || "").trim()); }

  function remember(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }
  function recall(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }


  /* ---------------- 9pm cut-off countdown (Sydney time) ---------------- */
  var DAYNAME = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  function pad(n) { return n < 10 ? "0" + n : String(n); }

  function sydneyNow() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat("en-AU", {
        timeZone: "Australia/Sydney", hour12: false,
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit"
      }).formatToParts(new Date());
    } catch (e) {
      var n = new Date();
      return { h: n.getHours(), mi: n.getMinutes(), s: n.getSeconds(), dow: n.getDay() };
    }
    var g = {};
    parts.forEach(function (p) { g[p.type] = p.value; });
    var h = parseInt(g.hour, 10); if (h === 24) h = 0;
    var dow = new Date(g.year + "-" + g.month + "-" + g.day + "T00:00:00").getDay();
    return { h: h, mi: parseInt(g.minute, 10), s: parseInt(g.second, 10), dow: dow };
  }

  function nextCollectionDay(fromDow, skipDays) {
    var d = (fromDow + skipDays) % 7;
    if (d === 0) d = 1;               /* never a Sunday */
    return DAYNAME[d];
  }

  function tickCountdown() {
    var el = document.querySelector("[data-countdown]");
    if (!el) return;
    var t = sydneyNow();
    var left = CUTOFF_HOUR * 3600 - (t.h * 3600 + t.mi * 60 + t.s);

    if (left > 0) {
      var hrs  = Math.floor(left / 3600);
      var mins = Math.floor((left % 3600) / 60);
      var secs = left % 60;
      var within = hrs > 0
        ? hrs + "h " + pad(mins) + "m " + pad(secs) + "s"
        : (mins > 0 ? mins + "m " + pad(secs) + "s" : secs + "s");
      var when = (t.dow === 6) ? "Monday" : "next-day";
      el.innerHTML = "Book within <em>" + within + "</em> for " + when + " collection";
    } else {
      el.innerHTML = "Tonight\u2019s 9pm cut-off has passed \u2014 next collection <em>" +
                     nextCollectionDay(t.dow, 2) + "</em>";
    }
  }

  tickCountdown();
  setInterval(tickCountdown, 1000);

  /* ---------------- header ---------------- */
  var burger = document.querySelector("[data-burger]");
  if (burger) {
    burger.addEventListener("click", function () {
      var m = document.getElementById("mobile-menu");
      if (m) m.classList.toggle("open");
    });
  }

  /* ---------------- FAQ accordions ---------------- */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest("[data-faq]");
    if (b) b.parentNode.classList.toggle("open");
  });

  /* ---------------- homepage postcode checker ---------------- */
  var pcForm = document.querySelector("[data-pc-form]");
  if (pcForm) {
    pcForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = pcForm.querySelector("input");
      var box = document.querySelector("[data-pc-result]");
      var v = (input.value || "").trim();
      var bookUrl = pcForm.getAttribute("data-book-url") || "/collections/all";
      if (!validPostcode(v)) {
        box.className = "pc-res no";
        box.textContent = "Please enter a 4-digit postcode.";
        return;
      }
      if (inArea(parseInt(v, 10))) {
        remember("bh_postcode", v);
        box.className = "pc-res ok";
        box.innerHTML = "✓ Yes — we collect at " + v + "." +
          '<span class="thin">We run ' + DAYS + " in your area. Order by 9pm tonight and we’re there tomorrow.</span>" +
          '<div style="margin-top:14px"><a class="btn btn--white btn--sm btn--block" href="' + bookUrl + '">Book a collection</a></div>';
      } else {
        box.className = "pc-res no";
        box.innerHTML = "We don’t collect at " + v + " yet." +
          '<span class="thin">Leave your email and you’ll be first to know when we reach you.</span>' +
          '<div style="margin-top:12px"><a class="btn btn--sm btn--block" href="/pages/contact">Join the waitlist</a></div>';
      }
    });
  }

  /* ---------------- product booking form ---------------- */
  var form = document.querySelector("[data-booking]");
  if (!form) return;

  var isPlan     = form.getAttribute("data-plan") === "true";
  var datesWrap  = form.querySelector("[data-dates]");
  var quickWrap  = form.querySelector("[data-quick]");
  var calToggle  = form.querySelector("[data-cal-toggle]");
  var dateInput  = form.querySelector("[data-date-value]");
  var dateHint   = form.querySelector("[data-date-hint]");
  var pcInput    = form.querySelector("[data-gate-input]");
  var pcBtn      = form.querySelector("[data-gate-btn]");
  var pcMsg      = form.querySelector("[data-gate-msg]");
  var pcHidden   = form.querySelector("[data-gate-value]");
  var addBtn     = form.querySelector("[data-add]");
  var summaryDate = form.querySelector("[data-summary-date]");
  var gateOk = false;

  /* ================= collection date \u2014 month calendar =================
     Customers pick from a real calendar, up to HORIZON_MONTHS ahead.
     Sundays are never selectable, and nothing before the 9pm cut-off
     allows. Change HORIZON_MONTHS to widen or narrow the window. */
  var HORIZON_MONTHS = 3;
  var FULLMON = ["January","February","March","April","May","June",
                 "July","August","September","October","November","December"];

  var calEarliest = null, calLatest = null, calView = null, calSel = null;

  function isoOf(d) {
    return d.getFullYear() + "-" +
           String(d.getMonth() + 1).padStart(2, "0") + "-" +
           String(d.getDate()).padStart(2, "0");
  }
  function fromIso(s) {
    var p = String(s).split("-");
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function sameMonth(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
  }
  /* a day is bookable if it is not a Sunday and sits inside the window */
  function bookable(d) {
    return d.getDay() !== 0 && d >= calEarliest && d <= calLatest;
  }

  function computeBounds() {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    calEarliest = new Date(today);
    calEarliest.setDate(calEarliest.getDate() + (now.getHours() >= CUTOFF_HOUR ? 2 : 1));
    while (calEarliest.getDay() === 0) calEarliest.setDate(calEarliest.getDate() + 1);

    /* three months out, then step back off a Sunday */
    calLatest = new Date(today);
    calLatest.setMonth(calLatest.getMonth() + HORIZON_MONTHS);
    while (calLatest.getDay() === 0) calLatest.setDate(calLatest.getDate() - 1);
  }

  function renderCal() {
    if (!datesWrap) return;
    var y = calView.getFullYear(), m = calView.getMonth();
    /* Monday-first column index for the 1st of the month */
    var lead = (new Date(y, m, 1).getDay() + 6) % 7;
    var days = new Date(y, m + 1, 0).getDate();

    var cells = "";
    for (var i = 0; i < lead; i++) cells += '<span class="cal-cell cal-empty"></span>';
    for (var day = 1; day <= days; day++) {
      var d = new Date(y, m, day), k = isoOf(d), ok = bookable(d);
      cells += '<button type="button" class="cal-cell' + (calSel === k ? " sel" : "") + '"' +
               ' data-iso="' + k + '"' + (ok ? "" : " disabled") +
               ' aria-label="' + prettyDate(k) + (ok ? "" : " \u2014 not available") + '"' +
               (calSel === k ? ' aria-current="date"' : "") + ">" + day + "</button>";
    }

    var atStart = sameMonth(calView, calEarliest);
    var atEnd   = sameMonth(calView, calLatest);

    datesWrap.innerHTML =
      '<div class="cal">' +
        '<div class="cal-top">' +
          '<span class="cal-mon">' + FULLMON[m] + " " + y + "</span>" +
          '<span class="cal-nav">' +
            '<button type="button" data-cal-prev aria-label="Previous month"' + (atStart ? " disabled" : "") + ">\u2039</button>" +
            '<button type="button" data-cal-next aria-label="Next month"' + (atEnd ? " disabled" : "") + ">\u203a</button>" +
          "</span>" +
        "</div>" +
        '<div class="cal-dow" aria-hidden="true"><span>M</span><span>T</span><span>W</span>' +
          "<span>T</span><span>F</span><span>S</span><span>S</span></div>" +
        '<div class="cal-grid" role="grid">' + cells + "</div>" +
      "</div>";
  }

  /* -- the quick row: the next few collection days, one tap each -- */
  var QUICK_DAYS = 6;

  function buildQuick() {
    if (!quickWrap) return;
    var today = new Date();
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var d = new Date(calEarliest), html = "", n = 0;

    while (n < QUICK_DAYS) {
      if (d.getDay() !== 0) {
        var k = isoOf(d);
        var diff = Math.round((d - today) / 86400000);
        var lbl = diff === 1 ? "Tomorrow" : DOW[d.getDay()];
        html += '<div class="date" data-iso="' + k + '" role="button" tabindex="0">' +
                  '<span class="dow">' + lbl + "</span>" +
                  '<span class="dnum">' + d.getDate() + "</span>" + MON[d.getMonth()] +
                "</div>";
        n++;
      }
      d.setDate(d.getDate() + 1);
    }
    quickWrap.innerHTML = html;
  }

  /* keep the two controls in step \u2014 only ever one visible selection */
  function syncSelection() {
    if (quickWrap) {
      Array.prototype.forEach.call(quickWrap.children, function (c) {
        c.classList.toggle("sel", c.getAttribute("data-iso") === calSel);
      });
    }
    renderCal();
  }

  function buildDates() {
    if (!datesWrap && !quickWrap) return;
    computeBounds();
    calSel = isoOf(calEarliest);
    calView = new Date(calEarliest.getFullYear(), calEarliest.getMonth(), 1);
    buildQuick();
    syncSelection();
    setDate(calSel);
    if (dateHint) {
      dateHint.textContent =
        "We collect Monday to Saturday \u2014 no Sunday collections. Order by 9pm for next-day, " +
        "or pick any date up to " + HORIZON_MONTHS + " months ahead.";
    }
  }

  function prettyDate(iso) {
    var p = iso.split("-");
    var dt = new Date(+p[0], +p[1] - 1, +p[2]);
    return DOW[dt.getDay()] + " " + dt.getDate() + " " + MON[dt.getMonth()] + " " + dt.getFullYear();
  }

  function setDate(iso) {
    if (!iso) return;
    if (dateInput) dateInput.value = prettyDate(iso);
    if (summaryDate) summaryDate.textContent = prettyDate(iso);
  }

  if (datesWrap) {
    datesWrap.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;

      if (e.target.closest("[data-cal-prev]")) {
        calView.setMonth(calView.getMonth() - 1);
        renderCal();
        return;
      }
      if (e.target.closest("[data-cal-next]")) {
        calView.setMonth(calView.getMonth() + 1);
        renderCal();
        return;
      }

      var cell = e.target.closest(".cal-cell");
      if (!cell || cell.disabled || cell.classList.contains("cal-empty")) return;
      calSel = cell.getAttribute("data-iso");
      syncSelection();
      setDate(calSel);
    });
  }

  /* quick row */
  if (quickWrap) {
    quickWrap.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var el = e.target.closest(".date");
      if (!el) return;
      calSel = el.getAttribute("data-iso");
      /* jump the calendar to the month of whatever they picked */
      var d = fromIso(calSel);
      calView = new Date(d.getFullYear(), d.getMonth(), 1);
      syncSelection();
      setDate(calSel);
    });
    quickWrap.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var el = e.target.closest && e.target.closest(".date");
      if (!el) return;
      e.preventDefault();
      el.click();
    });
  }

  /* show / hide the calendar */
  if (calToggle && datesWrap) {
    calToggle.addEventListener("click", function () {
      var open = datesWrap.hasAttribute("hidden");
      if (open) {
        /* always open on the month holding the current selection */
        var d = fromIso(calSel);
        calView = new Date(d.getFullYear(), d.getMonth(), 1);
        renderCal();
        datesWrap.removeAttribute("hidden");
      } else {
        datesWrap.setAttribute("hidden", "");
      }
      calToggle.setAttribute("aria-expanded", open ? "true" : "false");
      calToggle.textContent = open ? "Hide calendar" : "Pick another date";
    });
  }

  /* -- bin size / option cards -- */
  form.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var opt = e.target.closest(".opt");
    if (!opt) return;
    var group = opt.parentNode;
    Array.prototype.forEach.call(group.children, function (c) { c.classList.remove("sel"); });
    opt.classList.add("sel");
    var radio = opt.querySelector("input");
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
      if (radio.name === "id") syncPrice(radio.getAttribute("data-price"));
    }
  });

  function syncPrice(price) {
    if (!price) return;
    ["[data-price-display]", "[data-summary-price]", "[data-summary-total]"].forEach(function (sel) {
      /* the headline price sits outside the form element, so search the document */
      var els = document.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el) { el.textContent = price; });
    });
  }

  /* -- postcode gate -- */
  function checkGate() {
    var v = (pcInput.value || "").trim();
    if (!validPostcode(v)) {
      gateOk = false;
      pcMsg.className = "msg no";
      pcMsg.textContent = "Please enter a 4-digit postcode.";
    } else if (inArea(parseInt(v, 10))) {
      gateOk = true;
      remember("bh_postcode", v);
      if (pcHidden) pcHidden.value = v;
      pcMsg.className = "msg ok";
      pcMsg.textContent = "✓ We collect at " + v + " — " + DAYS + ".";
    } else {
      gateOk = false;
      pcMsg.className = "msg no";
      pcMsg.textContent = "Sorry — " + v + " is outside our collection area. Checkout won’t go through for this address.";
    }
    syncAdd();
  }

  function syncAdd() {
    if (!addBtn) return;
    addBtn.disabled = !gateOk;
    addBtn.textContent = gateOk
      ? (isPlan ? "Start my weekly plan" : "Book this collection")
      : "Check your postcode first";
  }

  if (pcBtn) pcBtn.addEventListener("click", checkGate);
  if (pcInput) {
    pcInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); checkGate(); }
    });
    var saved = recall("bh_postcode");
    if (saved) { pcInput.value = saved; checkGate(); }
  }

  buildDates();
  syncAdd();
})();
